import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-error-view',
  templateUrl: './error-view.component.html',
  styleUrls: ['./error-view.component.css']
})
export class ErrorViewComponent implements OnInit{

  @Input()  prepareError: Object|any;
  
  errorTitle: String="";
  errorMessage: String="";
  errorType: String="";

  constructor() { }

  ngOnInit() {
    this.errorTitle = this.prepareError['errorTitle'];
    this.errorMessage = this.prepareError['errorMessage'];
    this.errorType = this.prepareError['errorType'];
  }

}
